module.exports = __webpack_public_path__ + "static/media/brady-cutout.a6c13e1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brady-cutout.png
// module id = 352
// module chunks = 0